import { Navigate } from 'react-router-dom';
import { Layout } from './components/layout';
import CampaignPage from './pages/campaign-page';
import CampaignsPage from './pages/campaigns';
import CheckoutPage from './pages/checkout';
import GeneralCampaign from './pages/general-campaign';
import { NotFound } from './pages/not-found';
import RegularCampaign from './pages/regular-campaign';
import SignUpCamapaingPage from './pages/sign-up-campaign';
import AboutUsPage from './pages/static/about-us';
import ContactUsPage from './pages/static/contact-us';
import GetStartedPage from './pages/static/get-started';
import MainPage from './pages/static/main';
import MissionHebrewPage from './pages/static/mission-hebrew';
import MissionPage from './pages/static/mission-page';
import OurServicePage from './pages/static/our-service';
import ThankYouPage from './pages/thank-you';
import OurChampions from './pages/our-champions';

export const routes = [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <MainPage />
      },
      {
        path: '/partners/:partnerSlug',
        element: <MainPage />
      },
      {
        path: '/general-campaign/:campaignID',
        element: <GeneralCampaign />
      },
      {
        path: '/about-us',
        element: <AboutUsPage />
      },
      {
        path: '/sign-up-campaign',
        element: <SignUpCamapaingPage />
      },
      {
        path: '/campaigns',
        element: <CampaignsPage />
      },
      {
        path: '/campaign/:campaignID',
        element: <CampaignPage />
      },
      {
        path: '/why-us',
        element: <MissionPage />
      },
      {
        path: '/why-us-he',
        element: <MissionHebrewPage />
      },
      {
        path: '/campaign/:campaignID/:partnerSlug',
        element: <RegularCampaign />
      },
      {
        path: '/our-service',
        element: <OurServicePage />
      },
      {
        path: '/get-started',
        element: <GetStartedPage />
      },
      {
        path: '/contact-us',
        element: <ContactUsPage />
      },
      {
        path: '/donation-summary/:campaignSlug/:donationSum/:currency',
        element: <CheckoutPage />
      },
      {
        path: '/thank-you/:transactionType/:transactionID',
        element: <ThankYouPage />
      },
      {
        path: '/our-champions',
        element: <OurChampions />
      },
      {
          path: '404',
          element: <NotFound />
        }
     /*  {
        path: '/campaign/:slug',
        element: <regularCampaignPage />
      }, */
    ]
  },
  // {
  //   path: '404',
  //   element: <NotFound />
  // }
];
